import addAdvertisementProperty from "./addAdvertisementProperty";

const mapOverCriteo = (mightLikeProductItem, criteoAdverts) => {
  if (!mightLikeProductItem) return [];
  if (!criteoAdverts?.length) return mightLikeProductItem;

  const matchingAdvert = criteoAdverts.find(
    (criteoItem) =>
      Number(criteoItem.ParentSKU) === mightLikeProductItem.productId,
  );

  return matchingAdvert && "LineItemID" in matchingAdvert
    ? addAdvertisementProperty(mightLikeProductItem, matchingAdvert)
    : mightLikeProductItem;
};

export default mapOverCriteo;
